"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-monitor/migration.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-monitor%2Fmigration.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrationImpactToJSON = exports.migrationImpactFromJSON = exports.MigrationContext = exports.MigrationImpact = void 0;
const protobufPackage = 'com.step.creditmonitor.migration.proto';
var MigrationImpact;
(function (MigrationImpact) {
    MigrationImpact["INVALID_MIGRATION_IMPACT"] = "INVALID_MIGRATION_IMPACT";
    /**
     * POSITIVE - Score increased after migration.
     */
    MigrationImpact["POSITIVE"] = "POSITIVE";
    /**
     * NEUTRAL - Score remained same after migration.
     */
    MigrationImpact["NEUTRAL"] = "NEUTRAL";
    /**
     * NEGATIVE - Score decreased after migration.
     */
    MigrationImpact["NEGATIVE"] = "NEGATIVE";
    /**
     * UNKNOWN - The impact on credit score is unknown after migration.
     */
    MigrationImpact["UNKNOWN"] = "UNKNOWN";
    MigrationImpact["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MigrationImpact || (exports.MigrationImpact = MigrationImpact = {}));
function createBaseMigrationContext() {
    return {
        migratedAtMs: '0',
        migrationImpact: MigrationImpact.INVALID_MIGRATION_IMPACT,
        hasLegacyScore: false,
    };
}
exports.MigrationContext = {
    fromJSON(object) {
        const message = {
            migratedAtMs: isSet(object.migratedAtMs) ? globalThis.String(object.migratedAtMs) : '0',
            migrationImpact: isSet(object.migrationImpact)
                ? migrationImpactFromJSON(object.migrationImpact)
                : MigrationImpact.INVALID_MIGRATION_IMPACT,
        };
        if (isSet(object.hasLegacyScore)) {
            message.hasLegacyScore = globalThis.Boolean(object.hasLegacyScore);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.migratedAtMs !== '0') {
            obj.migratedAtMs = message.migratedAtMs;
        }
        if (message.migrationImpact !== MigrationImpact.INVALID_MIGRATION_IMPACT) {
            obj.migrationImpact = migrationImpactToJSON(message.migrationImpact);
        }
        if (message.hasLegacyScore !== undefined && message.hasLegacyScore !== false) {
            obj.hasLegacyScore = message.hasLegacyScore;
        }
        return obj;
    },
    create(base) {
        return exports.MigrationContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMigrationContext();
        message.migratedAtMs = object.migratedAtMs ?? '0';
        message.migrationImpact = object.migrationImpact ?? MigrationImpact.INVALID_MIGRATION_IMPACT;
        message.hasLegacyScore = object.hasLegacyScore ?? false;
        return message;
    },
};
function migrationImpactFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_MIGRATION_IMPACT':
            return MigrationImpact.INVALID_MIGRATION_IMPACT;
        case 1:
        case 'POSITIVE':
            return MigrationImpact.POSITIVE;
        case 2:
        case 'NEUTRAL':
            return MigrationImpact.NEUTRAL;
        case 3:
        case 'NEGATIVE':
            return MigrationImpact.NEGATIVE;
        case 4:
        case 'UNKNOWN':
            return MigrationImpact.UNKNOWN;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return MigrationImpact.UNRECOGNIZED;
    }
}
exports.migrationImpactFromJSON = migrationImpactFromJSON;
function migrationImpactToJSON(object) {
    switch (object) {
        case MigrationImpact.INVALID_MIGRATION_IMPACT:
            return 'INVALID_MIGRATION_IMPACT';
        case MigrationImpact.POSITIVE:
            return 'POSITIVE';
        case MigrationImpact.NEUTRAL:
            return 'NEUTRAL';
        case MigrationImpact.NEGATIVE:
            return 'NEGATIVE';
        case MigrationImpact.UNKNOWN:
            return 'UNKNOWN';
        case MigrationImpact.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.migrationImpactToJSON = migrationImpactToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=migration.js.map